import {Box, Center, Flex, Text} from '@chakra-ui/react'
import {useEffect, useState} from 'react'
import Loading from '@components/Loading'
import BannerRevise from '@assets/images/learn/notebook_banner.png'
import {useLocation, useNavigate} from 'react-router-dom'
import {updateIsShowHeaderBtn} from '@redux/revise/revise'
import {useDispatch, useSelector} from 'react-redux'
import ItemSentence from './ItemSentence'
import sentencePracticeRequest from '@apis/sentence-practice'
import {Widget} from '@typeform/embed-react'
import Lottie from 'lottie-react'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import {Modal} from 'antd'
import appRequest from '@apis/app'
import {getFeedbackOverview} from '@redux/shared/shared'
import ratingLottie from '@assets/lotties/rating.json'
import mapRequest from '@apis/map'
import {isParamsValid} from '@utils'
import {PATH} from '@utils/Const'

const colors = [
  '#F13B32',
  '#FF5E00',
  '#F80',
  '#FF9D00',
  '#FFB700',
  '#FBDA06',
  '#F5C929',
  '#8FD328',
  '#69BF3B',
  '#4CAF4F',
]

const ReviseSentenceResult = () => {
  const [summariesData, setSummariesData] = useState<any>([])
  const navigate = useNavigate()
  const dispatch: any = useDispatch()
  const location = useLocation()
  const {historyId, entry_point} = location.state || {}
  const {dataFeedbackOverview} = useSelector((state: any) => state.shared)
  const [isShowModalFeedback, setIsShowModalFeedback] = useState<boolean>(false)
  const [step, setStep] = useState<number>(1)
  const [feedbackData, setFeedbackData] = useState<any>()
  const [isShowTypeForm, setIsShowTypeForm] = useState<boolean>(false)

  useEffect(() => {
    if (!isParamsValid([historyId])) {
      navigate(PATH.HOME)
    }
  }, [])

  useEffect(() => {
    if (!historyId) return
    getSentenceSummary()
  }, [])

  useEffect(() => {
    if (!dataFeedbackOverview) return
    if (
      entry_point === 'ROADMAP' &&
      !dataFeedbackOverview?.feedback_data?.FINISH_SENTENCE_PRACTICE
        ?.is_completed
    ) {
      setIsShowModalFeedback(true)
      getFeedbackData()
    }
  }, [entry_point, dataFeedbackOverview])

  const getSentenceSummary = async () => {
    try {
      const params = {sentencePracticeHistoryId: historyId}
      const res = await sentencePracticeRequest.getSentenceSummary(params)
      if (res) {
        if (res.status === 200) {
          setSummariesData(res.data.data)
        }
      }
    } catch (error) {}
  }

  const getFeedbackData = async () => {
    try {
      const params = {
        'feedback-id':
          dataFeedbackOverview?.feedback_data?.FINISH_SENTENCE_PRACTICE
            ?.feedback_id || '',
      }
      const res = await mapRequest.getFeedbackData(params)
      if (res) {
        setFeedbackData(res?.data?.data)
      }
    } catch (error) {}
  }

  const handleClick = () => {
    navigate(-2)
    dispatch(updateIsShowHeaderBtn(false))
  }

  const handleClickSkip = () => {
    setIsShowModalFeedback(false)
  }

  const handleSubmitTypeForm = () => {
    setIsShowModalFeedback(false)
  }

  const handleClickRate = async (score: number) => {
    if (feedbackData?.feedback_data?.typeform_id) {
      setStep(2)
    } else {
      setIsShowModalFeedback(false)
    }
    try {
      const params = {
        feedback_data_id:
          dataFeedbackOverview?.feedback_data?.FINISH_SENTENCE_PRACTICE
            ?.feedback_id,
        score: score,
        feature: 'SENTENCE_PRACTICE',
      }
      const res = await appRequest.submitFeatureFeedback(params)
      dispatch(getFeedbackOverview())
    } catch (error) {}
  }

  return (
    <Box minH={'100vh'}>
      <Box
        className="HeaderRevise"
        minH={'400px'}
        bgImage={BannerRevise}
        bgRepeat={'no-repeat'}
        bgSize={'cover'}
        borderRadius={'0px 0px 100px 100px'}>
        <Flex
          flexDirection={{base: 'column', md: 'row'}}
          justifyContent={'space-between'}
          pt={{base: '32px', md: '54px'}}
          gap={'16px'}
          maxW={'1280px'}
          mx={'auto'}
          px={{base: '24px', md: '70px'}}>
          <Flex
            flexDirection={'column'}
            textAlign={{base: 'center', md: 'unset'}}
            color={'#002766'}>
            <Text fontSize={{base: '18px', md: '24px'}} fontWeight={600}>
              Chúc mừng bạn đã hoàn thành phần Ôn tập!
            </Text>
            <Text fontSize={{base: '14px', md: '16px'}} mt={'24px'}>
              Cùng xem lại các câu từ bạn đã hoàn thành nhé
            </Text>
          </Flex>
          <Center>
            {true && (
              <Flex
                bg={'#FFA800'}
                p={'12px 24px'}
                borderRadius={'12px'}
                gap={'8px'}
                _hover={{bg: '#ffbb37'}}
                cursor={'pointer'}
                onClick={handleClick}>
                <Text fontSize={'16px'} color={'white'} fontWeight={700}>
                  Trở về
                </Text>
                {/* <Icon
                  w={'24px'}
                  h={'24px'}
                  sx={{
                    stroke: 'white',
                  }}>
                  <ArrowRight4 />
                </Icon> */}
              </Flex>
            )}
          </Center>
        </Flex>
      </Box>
      <Flex
        maxW={'1280px'}
        h={{base: 'unset', md: '500px'}}
        mx={{base: '8px', md: '24px', xl: 'auto'}}
        mt={{base: '-170px', md: '-200px'}}
        mb={'32px'}
        borderRadius={'20px'}
        bg={'white'}>
        <Box
          className="scroll-bar"
          m={'24px'}
          mr={'0px'}
          pr={'24px'}
          overflow={'auto'}
          flex={1}
          position={'relative'}>
          {true ? (
            summariesData?.map((item: any, index: any) => {
              return <ItemSentence key={index} data={item} type="complete" />
            })
          ) : (
            <Loading />
          )}
        </Box>
      </Flex>
      <Modal
        open={isShowModalFeedback}
        width={'850px'}
        onCancel={() => setIsShowModalFeedback(false)}
        footer={null}>
        <>
          {step === 1 && (
            <Flex flexDirection={'column'} alignItems={'center'} py={'50px'}>
              <Box>
                <Text align={'center'} fontSize={'24px'} fontWeight={600}>
                  {feedbackData?.feedback_data?.text}
                </Text>
                <Text align={'center'} mt={'20px'}>
                  {feedbackData?.feedback_data?.sub_text}
                </Text>
                <Flex mt={'40px'} justifyContent={'center'} gap={'32px'}>
                  {Array.from({
                    length: Number(feedbackData?.feedback_data?.total_score),
                  }).map((_, index) => (
                    <Box
                      key={index}
                      w={'48px'}
                      h={'48px'}
                      position={'relative'}>
                      <Center
                        bg={colors[index]}
                        cursor={'pointer'}
                        borderRadius={'50%'}
                        fontSize={'24px'}
                        fontWeight={600}
                        position={'absolute'}
                        w={'100%'}
                        h={'100%'}
                        color={'white'}
                        opacity={0.4}
                        transition={'all 0.3s'}
                        _hover={{
                          opacity: 1,
                          transform: 'scale(1.2)',
                        }}
                        onClick={() => handleClickRate(index + 1)}>
                        {index + 1}
                      </Center>
                      {(index === 0 || index === 9) && (
                        <Text
                          position={'absolute'}
                          bottom={'-40px'}
                          left={'50%'}
                          transform={'translateX(-50%)'}
                          fontWeight={600}
                          style={{
                            textWrap: 'nowrap',
                          }}>
                          {index === 0
                            ? feedbackData?.feedback_data?.min
                            : feedbackData?.feedback_data?.max}
                        </Text>
                      )}
                    </Box>
                  ))}
                </Flex>
              </Box>
            </Flex>
          )}
          {step === 2 && (
            <Flex flexDirection={'column'} alignItems={'center'} mt={'100px'}>
              <>
                {isShowTypeForm ? (
                  <Box className="typeform-iframe">
                    <Widget
                      id={feedbackData?.feedback_data?.typeform_id}
                      style={{width: '700px', height: '500px'}}
                      onSubmit={handleSubmitTypeForm}
                    />
                  </Box>
                ) : (
                  <>
                    <Box w={'300px'}>
                      <Lottie animationData={ratingLottie} />
                    </Box>
                    <Text
                      fontSize={'24px'}
                      fontWeight={600}
                      textAlign={'center'}>
                      Chúng mình muốn biết ý kiến của bạn
                    </Text>
                    <Text
                      fontWeight={400}
                      mt={'16px'}
                      maxW={'405px'}
                      textAlign={'center'}>
                      Mời bạn tham gia khảo sát sau để giúp chúng mình hiểu hơn
                      về nhu cầu học của bạn
                    </Text>
                    <GlobalButton
                      px={'40px'}
                      py={'22px'}
                      mt={'40px'}
                      borderRadius={'12px'}
                      onClick={() => setIsShowTypeForm(true)}>
                      Làm khảo sát
                    </GlobalButton>
                    <GlobalButton
                      fontSize={'16px'}
                      fontWeight={600}
                      mt={'16px'}
                      color={'#007EF5'}
                      bg={'transparent'}
                      _hover={{
                        bg: '#e3f2ff',
                      }}
                      onClick={handleClickSkip}>
                      Để sau
                    </GlobalButton>
                  </>
                )}
              </>
            </Flex>
          )}
        </>
      </Modal>
    </Box>
  )
}

export default ReviseSentenceResult
